export default __webpack_public_path__ + "static/article-home-improvement-trends-6edd15f6adb9aab48f08e2e34c7d8fd9.jpg";